import React from 'react';
import { observer } from 'mobx-react';
import './Training.scss';
import externalLink from '../../../assets/images/link output.svg';
import { mdiInformationOutline } from '@mdi/js';
import Icon from '@mdi/react';

const TrainingComponent = () => {
  return (
    <div className="training-container" >
      <h1 tabIndex={0}>NETS Training and Support Material</h1>
      <div className="training-h2" tabIndex={0}>
        <p>
          Information to support the use of NETS includes informative tool tips in portions of the application. Look for the informational icon <Icon path={mdiInformationOutline} color="#005ea2" size={1} title={' information'}  /> adjacent to a term or section header.
        </p>
        <p>
          Additional information can be found in the Glossary/Help section. This section can be accessed at the bottom
          of the main menu on the left side of the NETS homepage.
        </p>
        <p>
          More detailed training and support resources are located at the{' '}
          <a
            className="training-link"
            href="https://teams.microsoft.com/l/team/19%3aqpBIeQD2bhv2qJdLMsCp3bIir4b0h4L3NpzRbOvwznU1%40thread.tacv2/conversations?groupId=f985e768-c706-43a0-9cb2-04a1537cfb25&tenantId=ed5b36e7-01ee-4ebc-867e-e03cfa0d4697"
            title="Link to Team Chat Site"
            target="_blank"
          >
            FPAC – NETS (NRCS Engineering Tool Suite) Team
          </a>
          &nbsp;&nbsp;
          <img src={externalLink} alt="external link icon" width={12} height={12} />
        </p>
        <p>
          The NETS Microsoft Teams site contains short video tutorials showing examples of completing specific tasks
          NETS users will need to complete. The NETS Microsoft Teams site also has Quick Reference Documents explaining
          concepts important for NETS users to understand. The NETS Team additionally allows users to post questions and
          comments for the support team to review and provide answers.
        </p>
      </div>
    </div>
  );
};

export const TrainingComp = observer(TrainingComponent);
